import { AxiosResponse } from "axios";

import API from "../api";

import { RoomJob } from "../models/sales";
import { TaskType } from "../models/task.type";

const ROUTE_NAME = "jobs/quotes";
const ROUTE_NAME_INVENTORY = "jobs/inventory";

const QuoteService = {
  async approve(id: number): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/approve/${id}`);
  },
  async decline(id: number): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/decline/${id}`);
  },
  async cancel(id: number, reason: string): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/cancel/${id}`, { reason });
  },
  async types(): Promise<AxiosResponse<TaskType[]>> {
    return await API.get(`/${ROUTE_NAME}/types`);
  },
  async getAll(options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`/${ROUTE_NAME}/web/list`, { params: options });
  },
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/web/count`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`/${ROUTE_NAME}/web/${id}`, { params: options });
  },
  async create(quote: any): Promise<AxiosResponse<any>> {
    console.log("[QuoteService.create] Sending quote with timezone:", {
      original: { timezone: quote.timezone, timezoneId: quote.timezoneId },
    });

    return await API.post(`/${ROUTE_NAME}`, quote);
  },
  async update(id: number, quote: any, options?: UpdateOptions): Promise<AxiosResponse<boolean>> {
    console.log("[QuoteService.update] Updating quote with timezone:", {
      id,
      original: { timezone: quote.timezone, timezoneId: quote.timezoneId },
    });

    return await API.put(`/${ROUTE_NAME}/${id}`, quote, { params: options });
  },
  async updateToBeEditable(
    id: number,
    quote: any,
    options?: UpdateOptions
  ): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/enable/${id}`, quote, { params: options });
  },
  async updateInventory(id: number, inventory: RoomJob[]): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME_INVENTORY}/${id}`, inventory);
  },
  async delete(id: number): Promise<AxiosResponse<any>> {
    return await API.delete(`/${ROUTE_NAME}/${id}`);
  },
};

export default QuoteService;

type UpdateOptions = {
  actions?: string[];
};
